import { CHAT_TYPE, IGroupInfo, IUserInfo } from "@home-health-notify/domain";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useTranslation, CALENDAR_TABS } from "hhn-commons";
import React from "react";
import {
  BackButton,
  CalendarHeaderWrapper,
  CalendarHeading,
  LeftTab as CompletedTab,
  RightTab as ProjectedTab,
  StyledTabs as CalendarTabs,
  TabLabel,
  TabsWrapper as CalendarTabsWrapper,
} from "./Calendar.style";
import LupaModal from "./LupaModal";

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface CalendarHeaderProps {
  currentTab: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  closeModal: () => void;
  info?: IGroupInfo | IUserInfo;
}

const CalendarHeader = ({
  currentTab,
  onTabChange,
  closeModal,
  info,
}: CalendarHeaderProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "calendar" });

  const isCompletedTab = currentTab === CALENDAR_TABS.COMPLETED;
  const isProjectedTab = currentTab === CALENDAR_TABS.PROJECTED;
  const isGroupChat = info && info.chatType === CHAT_TYPE.GROUP;

  return (
    <CalendarHeaderWrapper info={info}>
      <BackButton
        variant={"outlined"}
        data-testid="back-button"
        onClick={closeModal}
      >
        <ChevronLeftIcon fontSize={"medium"} />
        {t("buttonLabels.back")}
      </BackButton>
      <CalendarHeading data-testid="calendar-heading">
        {info ? info.name : tNs("myCalendar")}
      </CalendarHeading>
      {isGroupChat && <LupaModal groupInfo={info as IGroupInfo} />}
      <CalendarTabsWrapper>
        <CalendarTabs
          value={currentTab}
          onChange={onTabChange}
          aria-label={CALENDAR_TABS.COMPLETED ? "completed" : "projected"}
        >
          <CompletedTab
            isCurrent={isCompletedTab}
            data-testid="completed-tab"
            label={
              <TabLabel isCurrent={isCompletedTab}>{tNs("completed")}</TabLabel>
            }
            {...a11yProps(0)}
          />
          <ProjectedTab
            isCurrent={isProjectedTab}
            data-testid="projected-tab"
            label={
              <TabLabel isCurrent={isProjectedTab}>{tNs("projected")}</TabLabel>
            }
            {...a11yProps(1)}
          />
        </CalendarTabs>
      </CalendarTabsWrapper>
    </CalendarHeaderWrapper>
  );
};

export default CalendarHeader;
